import { render, staticRenderFns } from "./VehicleAssessment.vue?vue&type=template&id=70f2b547&"
import script from "./VehicleAssessment.vue?vue&type=script&lang=js&"
export * from "./VehicleAssessment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports